// Utilities extracted from PusherModule.js

import _ from "lodash";
import { connectionManager } from "lib/ablyInstance";
import ACLStore from "lib/aclStore";
import Ably from "ably";
import { PUSHER_APP_KEY } from "store/static";

const PUSHER_EVENTS_MAPPING = {
  "notification-added": ["notificationAdded"],
  pages_thumburl_updated: ["pagesThumburlUpdated"],
  project_field_update: ["projectFieldUpdate"],
  unit_plan_created: ["unitPlanFeedUpdate"],
  assessment_changed: ["unitPlanResourceLibraryFeedUpdate"],
  le_changed: ["unitPlanResourceLibraryFeedUpdate"],
  unit_flow_changed: ["unitFlowFeedUpdate"],
  unit_flow_section_updated: ["unitFlowSectionUpdate"],
  unit_flow_child_resources_updated: ["unitFlowChildResourcesUpdated"],
  unit_flow_resources_updated: ["unitFlowResourcesUpdated"],
  unit_plan_resources_updated: ["unitPlanResourcesUpdated"],
  unit_plan_child_resources_updated: ["unitPlanChildResourcesUpdated"],
  assessment_resources_updated: ["assessmentResourcesUpdated"],
  resource_changed: ["resourcesFeedUpdate"],
  unit_plan_updated: ["unitPlanFieldUpdate"],
  unit_collaborator_added: ["unitPlanCollaboratorUpdate"],
  assessment_updated: ["assessmentFieldUpdate"],
  le_updated: ["leFieldUpdate"],
  "comment-added": ["nodeTotalCommentUpdate", "nodeCommentFeedUpdate"],
  CONVERSATION_INITIATED: ["chatMessageReceived"],
  USER_MESSAGE_RECEIVED: ["chatMessageReceived"],
  INSERT_CHANNEL_ACTIVITY: ["chatMessageReceived"],
  USER_MESSAGE_UPDATED: ["chatMessageReceived"],
  USER_MESSAGE_DELETED: ["chatMessageReceived"],
  ASSIGNMENT_ACTIVITY_LOGGED: ["assignmentActivityReceived"],
  MESSAGE_REACTION_ADDED: ["chatMessageToggleReaction"],
  MESSAGE_REACTION_REMOVED: ["chatMessageToggleReaction"],
  USER_MESSAGE_READ: ["chatMessageReadReceipt"],
  MARK_MESSAGE_READ: ["chatMessageV2ReadReceipt"],
  MARK_MESSAGE_READ_V2: ["chatMessageV3ReadReceipt"],
  STUDENT_ASSIGNMENT_SUBMISSION_REAL_TIME: ["studentAssignmentSubmitted"],
  ZOOM_MEETING_REAL_TIME: ["zoomMeetingUpdate"],
  ASSIGNMENT_CREATE: ["assignmentFeedUpdate"],
  ASSIGNMENT_DELETE: ["assignmentFeedUpdate"],
  ASSIGNMENT_UPDATE: ["assignmentFeedUpdate"],
  ASSIGNMENT_ARCHIVE: ["assignmentFeedUpdate"],
  ASSIGNMENT_UNARCHIVE: ["assignmentFeedUpdate"],
  ASSIGNMENT_MEETING_SCHEDULED: ["startingSoonAssignmentFeedUpdate"],
  STUDENT_ASSIGNMENT_SUBMISSION_FEEDBACK: ["assignmentFeedUpdate"],
  CALENDAR_EVENT_ITEM: [
    "startingSoonAssignmentFeedUpdate",
    "calendarEventsUpdate",
  ],
  CALENDAR_EVENT_ITEM_REMOVE_UPCOMING: ["startingSoonAssignmentFeedUpdate"],
  PLATFORM_CALENDAR_EVENT_CREATE: ["calendarEventsUpdate"],
  PLATFORM_CALENDAR_EVENT_UPDATE: ["calendarEventsUpdate"],
  PLATFORM_CALENDAR_EVENT_DELETE: ["calendarEventsUpdate"],
  ASSIGNMENT_MARK_COMPLETED: ["assignmentDetailsUpdate"],
  SUB_TASK_CHANGED: ["subTaskChanged"],
  ATTACHMENT_SIMILARITY_REPORT_UPDATE: ["attachmentSimilarityReportUpdate"],
  STUDENT_PROGRESS_REPORT_STATUS_UPDATE: ["studentProgressReportStatusUpdate"],
  JOB_FEED_UPDATE: ["JobFeedUpdate"],
  IMPORT_SUBJECT_STANDARDS_JOB_UPDATED: ["importSubjectStandardsJobUpdated"],
  FILTER_FEED_UPDATE: ["FilterJobFeedUpdate"],
  FETCH_TPS_ENTITIES_UPDATE: ["FetchTpsEntitiesUpdate"],
  MANAGE_FAMILY_FEED_UPDATE: ["ManageFamilyFeedUpdate"],
  STUDENT_PROGRESS_REPORT_SHARED: ["studentProgressReportShared"],
  LEARNING_COURSE_FLOW_FEED_UPDATE: ["courseFlowFeedUpdate"],
  LEARNING_COURSE_FLOW_RESOURCE_UPDATE: ["courseFlowResourceUpdate"],
  USER_PROJECT_UPDATED: ["userProjectUpdated"],
  ENTITY_LOCKING_STATE_UPDATED: [
    "entityLockingStateUpdated",
    "assignmentFeedUpdate",
  ],
  PUBLISH_SCHEDULED_JOURNAL_POST_REALTIME: [
    "publishScheduledJournalPostRealtime",
  ],
  CLASS_PLANNER_UPDATE: ["classPlannerUpdate"],
  CLASS_PLANNER_SECTION_UPDATE: ["classPlannerSectionUpdate"],
  LTI_ORGANIZATION_RESOURCE_CREATED: ["ltiSuccess"],
  UNIT_PLAN_BULK_IMPORT: ["unitPlanFeedUpdate"],
  CLASS_MATERIALS_UPDATE: ["classFlowFeedUpdate"],
  CLASS_FLOW_FEED_UPDATE: ["classFlowFeedUpdate"],
  CLASS_FLOW_RESOURCE_UPDATE: ["classFlowResourceUpdate"],
  ENTITY_FLOW_FEED_UPDATE: ["unitFlowFeedUpdate"],
  ENTITY_FLOW_RESOURCE_UPDATE: ["unitFlowResourceUpdate"],
  worksheet_started: ["worksheetStarted"],
  PREVIEW_AI_CHAT_EVALUATED: ["previewAIChatEvaluated"],
  STUDENT_AI_CHAT_EVALUATED: ["studentAIChatEvaluated"],
  AYT_WIZARD_MARK_COMPLETED: ["aytWizardMarkCompleted"],
  ASSIGNMENT_STUDENT_TEMPLATE_ADDED: ["submissionTemplateUpdate"],
  ASSIGNMENT_STUDENT_TEMPLATE_ADDITION_FAILED: ["submissionTemplateUpdate"],
  ASSESSMENT_TYPE_UPDATED: ["assessmentTypeUpdated"],
  LTI_ATTACHMENT_SUBMITTED: ["ltiAttachmentSubmitted"],
  QUESTION_EXTRACTION_JOB: ["questionExtractionJob"],
  PROJECT_SUBMISSION_LOCKING_STATE_UPDATED: [
    "projectSubmissionLockingStateUpdated",
  ],
  PROJECT_SUBMISSION_TURNED_IN: ["projectSubmissionLockingStateUpdated"],
  PROJECT_SUBMISSION_LOCKED: ["projectSubmissionLockingStateUpdated"],
  PROJECT_SUBMISSION_UNLOCKED: ["projectSubmissionLockingStateUpdated"],
  PROJECT_TASK_MARKED_COMPLETED: ["projectSubmissionLockingStateUpdated"],
  WORKFLOW_PROGRESS_STARTED: ["workflowProgressStarted"],
  WORKFLOW_PROGRESS_UPDATE: ["workflowProgressUpdate"],
  WORKFLOW_JOB_COMPLETED: ["workflowJobCompleted"],
  ANALYZING_ASSIGNMENT_CRITERIA: ["analyzingAssignmentCriteria"],
  READING_STUDENT_WORK: ["readingStudentWork"],
  GENERATING_FEEDBACK: ["generatingFeedback"],
  PREPARING_JUSTIFICATION: ["preparingJustification"],
  COMPLETED: ["completed"],
  AI_GRADING_FAILED: ["aiGradingFailed"],
  SENTRAL_OAUTH_USER_VERIFICATION_FAILED: [
    "sentralOauthUserVerificationFailed",
  ],
  SENTRAL_OAUTH_USER_VERIFICATION_COMPLETE: [
    "sentralOauthUserVerificationComplete",
  ],
  MANAGEBAC_GRADEBOOK_PARSED: ["managebacGradebookParsed"],
  TODDLE_GRADEBOOK_PARSED: ["toddleGradebookParsed"],
  TODDLE_GRADEBOOK_IMPORTED: ["toddleGradebookImported"],
  WORKSHEET_MONITORING: ["worksheetMonitoring"],
  WORKSHEET_LOCKING_STATE_UPDATED: ["worksheetLockingStateUpdated"],
  BULK_ADDITION_OF_STUDENT_RESPONSE_TO_PORTFOLIO_COMPLETED: [
    "bulkAddStudentResponseToPortfolioCompleted",
  ],
  BULK_DOWNLOAD_FOR_STUDENT_RESPONSE_IS_READY: [
    "bulkDownloadForStudentResponseIsReady",
  ],
  FAILED: ["failed"],
  FETCHING_TRANSCRIPT: ["fetchingTranscript"],
  PREPARING_ENHANCED_TRANSCRIPT: ["preparingEnhancedTranscript"],
  UPLOADING_ENHANCED_TRANSCRIPT: ["uploadingEnhancedTranscript"],
  ANNOUNCEMENT_AI_CREATION: ["announcementAICreation"],
  CALENDAR_EVENT_ITEM_TOAST_SHOW: ["videoMeetingToastUpdate"],
  CALENDAR_EVENT_ITEM_TOAST_HIDE: ["videoMeetingToastUpdate"],
  CALENDAR_EVENT_ITEM_CREATE: ["videoMeetingToastUpdate"],
  CALENDAR_EVENT_ITEM_UPDATE: ["videoMeetingToastUpdate"],
  CALENDAR_EVENT_ITEM_DELETE: ["videoMeetingToastUpdate"],
};

export const getFieldLockedObject = _.memoize(
  ({ uids, lockedFields, fieldId = null, isProject = false }) => {
    let lockedField = _.find(
      lockedFields,
      field => _.includes(uids, _.get(field, "uid")) && !field.id
    );
    if (isProject) {
      lockedField = _.find(
        lockedFields,
        field =>
          _.includes(uids, _.get(field, "uid")) &&
          !field.id &&
          field.fieldId === fieldId
      );
    }
    const lockedDynamicFields = _.filter(lockedFields, field =>
      _.includes(uids, _.get(field, "uid"))
    );
    return { lockedField, lockedDynamicFields };
  },
  params => JSON.stringify(params)
);

const getChannelName = ({ data = {}, channelType }) => {
  const {
    organizationId,
    userId,
    unitPlanId,
    unitFlowSectionId,
    learningCourseId,
    leId,
    assessmentId,
    projectId,
    courseId,
  } = data;
  let channelName = null;
  switch (channelType) {
    case "user":
      channelName = `user_${organizationId}_${userId}`;
      break;

    case "unitPlan":
      channelName = `org_${organizationId}_unitplan_${unitPlanId}`;
      break;

    case "uniflowSection":
      channelName = `org_${organizationId}_unitflowsection_${unitFlowSectionId}`;
      break;

    case "le":
      channelName = `org_${organizationId}_le_${leId}`;
      break;

    case "assessment":
      channelName = `org_${organizationId}_assessment_${assessmentId}`;
      break;
    case "project":
      channelName = `project_${organizationId}_${projectId}`;
      break;

    case "ayt":
      channelName = `ayt_${organizationId}`;
      break;

    case "assignments":
      channelName = `class_${courseId}_assignments`;
      break;

    case "classFlow":
      channelName = `class_${courseId}_class_flow`;
      break;

    case "courseFlow":
      channelName = `org_${organizationId}_learning_course_${learningCourseId}`;
      break;

    case "worksheet":
      channelName = `org_${organizationId}_worksheet_${assessmentId}`;
      break;
  }
  return channelName;
};

export const getChannelInstance = ({ data = {}, channelType }) => {
  const conn = connectionManager.getConnection();
  if (!conn) {
    return null;
  }

  const channelName = getChannelName({ data, channelType });
  const channel = conn.channels.get(channelName);
  return channel;
};

export const getLockedFieldsFromMembers = members => {
  return _.reduce(
    members,
    (result, member) => {
      const { data: { userInfo = {}, lockedField } = {} } = member;
      if (lockedField) {
        result.push({ ...lockedField, userInfo });
      }
      return result;
    },
    []
  );
};

export const getMembersOfPresenceChannel = ({ channel }) => {
  if (!channel) {
    return [];
  }
  let channelMembers = [];
  channel.presence.get(function (err, members) {
    channelMembers = members;
  });
  return _.filter(
    channelMembers,
    member =>
      member.connectionId !=
      _.get(connectionManager.getConnection(), "connection.id", "")
  );
};

export const setPusherConnection = userId => {
  if (
    connectionManager.getConnection() &&
    ACLStore.can("SpawnSingleAblyConnection")
  ) {
    return;
  }
  connectionManager.setConnection(
    new Ably.Realtime({
      key: PUSHER_APP_KEY,
      clientId: userId,
    })
  );
};

// Auto-generated exports
export { PUSHER_EVENTS_MAPPING, getChannelName };
